import { Star, StarHalf } from 'lucide-react';
import React from 'react'

type StarsProps = {
  value: number;
  max: number;
}

const starIcon = {
  half: <StarHalf className="size-3" style={{ color: '#EAB308' }} />,
  full: <Star className="size-3" fill="#EAB308" style={{ color: '#EAB308' }} />,
  empty: <Star className="size-3" style={{ color: '#D4D4D4' }} />,
}

const Stars: React.FC<StarsProps> = (props) => {
  const { value, max } = props;

  return (
    <span className="flex items-center">
      {Array.from({ length: max }).map((_, index) => (
        <span key={index}>
          {index < value ? (
            starIcon.full
          ) : (
            starIcon.empty
          )}
        </span>
      ))}
    </span>
  );
}

export default Stars;